var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"slider",staticClass:"custom-slider",class:'custom-slider-type-' + (_vm.type || 'unknown'),attrs:{"id":'custom-slider-' + _vm._uid}})])}
var staticRenderFns = []

export { render, staticRenderFns }